import PropTypes from 'prop-types';
import { Card, CardContent, Chip, Stack, TextField, Typography } from '@mui/material';

export default function AdminFilterBar({ title, hint, filters }) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={2}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={2}
            alignItems={{ xs: 'flex-start', md: 'center' }}
            justifyContent="space-between"
          >
            <Stack spacing={0.5}>
              <Typography variant="subtitle1">{title}</Typography>
              <Typography variant="body2" color="text.secondary">
                {hint}
              </Typography>
            </Stack>
            <TextField size="small" placeholder="Search by reference, staff ID, or user ID" sx={{ minWidth: 260 }} />
          </Stack>
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {filters.map((filter) => (
              <Chip key={filter} label={filter} variant="outlined" />
            ))}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

AdminFilterBar.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.string),
  hint: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

AdminFilterBar.defaultProps = {
  filters: [],
};
